import { Brain, Target, Sparkles, Lightbulb, Rocket } from 'lucide-react';

// Shared team data — single source of truth for TeamSection (home), /equipo and /equipo/:slug
export const TEAM = [
  {
    slug: 'david-redondo-perez',
    name: 'David Redondo Pérez',
    roleEs: 'Head of Innovation & AI',
    roleEn: 'Head of Innovation & AI',
    bioEs: 'Ingeniero agrónomo. Head of Innovation & AI en Valoriza Servicios Medioambientales. Más de diez años haciendo que la tecnología sobreviva al turno, no solo a la demo.',
    bioEn: 'Agronomist engineer. Head of Innovation & AI at Valoriza Servicios Medioambientales. Over ten years making technology survive the shift, not just the demo.',
    icon: Brain,
    color: '#8DC21F',
    linkedin: 'https://www.linkedin.com/in/davidredondoperez',
    photo: 'https://customer-assets.emergentagent.com/job_valoriza-ideas/artifacts/q6qxiooa_image.png',
    personalSite: 'https://davidredondo.xyz',
  },
  {
    slug: 'paloma-mingo-de-vierna',
    name: 'Paloma Mingo de Vierna',
    roleEs: 'R&D Projects, Patents & Grants Manager',
    roleEn: 'R&D Projects, Patents & Grants Manager',
    bioEs: 'Impulsa la excelencia en I+D y la captación de financiación estratégica. Lidera proyectos de innovación: de iniciativas de economía circular a tecnologías de valorización de residuos.',
    bioEn: 'Driving R&D excellence and securing strategic funding. Leading innovation projects, from circular economy initiatives to cutting-edge waste valorization technologies.',
    icon: Target,
    color: '#3b82f6',
    linkedin: 'https://www.linkedin.com/in/paloma-mingo-de-vierna-1899a435/',
    photo: 'https://customer-assets.emergentagent.com/job_valoriza-ideas/artifacts/cysj2wz4_image.png',
  },
  {
    slug: 'blanca-almendro-gordillo',
    name: 'Blanca Almendro Gordillo',
    roleEs: 'Open Innovation, Ecosystem & Growth Lead',
    roleEn: 'Open Innovation, Ecosystem & Growth Lead',
    bioEs: 'Construye el ecosistema de innovación con startups, universidad y hubs tecnológicos. MBA con experiencia internacional. Open innovation y partnerships de impacto.',
    bioEn: 'Building innovation ecosystems across startups, academia and tech hubs. MBA with international experience driving open innovation culture and strategic partnerships for disruptive impact.',
    icon: Sparkles,
    color: '#f59e0b',
    linkedin: 'https://www.linkedin.com/in/blancaalmendro/',
    photo: 'https://customer-assets.emergentagent.com/job_valoriza-ideas/artifacts/yhr19dp9_image.png',
  },
  {
    slug: 'maria-luisa-fombellida-mate',
    name: 'María Luisa Fombellida Maté',
    roleEs: 'Open Innovation & Ecosystem Analyst',
    roleEn: 'Open Innovation & Ecosystem Analyst',
    bioEs: 'Detecta tendencias y tecnologías. Conecta ciencia, industria y ecosistema para acelerar soluciones ambientales y proyectos de economía circular.',
    bioEn: 'Spotting emerging trends and game-changing technologies. Connecting science, industry and innovation ecosystems to accelerate environmental solutions and circular economy projects.',
    icon: Lightbulb,
    color: '#8b5cf6',
    linkedin: 'https://www.linkedin.com/in/maria-luisa-fombellida-mat%C3%A9-619abb274/',
    photo: 'https://customer-assets.emergentagent.com/job_valoriza-ideas/artifacts/9qd3nuwf_image.png',
  },
  {
    slug: 'maria-useros-meson',
    name: 'María Useros Mesón',
    roleEs: 'R&D Project Manager',
    roleEn: 'R&D Project Manager',
    bioEs: 'Pasa conceptos de ingeniería ambiental a proyecto real. Orquesta I+D compleja, de la idea al despliegue en gestión sostenible de residuos.',
    bioEn: 'Transforming environmental engineering concepts into reality. Orchestrating complex R&D projects with precision, from ideation to deployment in sustainable waste management.',
    icon: Rocket,
    color: '#10b981',
    linkedin: 'https://www.linkedin.com/in/mariauseros/',
    photo: 'https://customer-assets.emergentagent.com/job_valoriza-ideas/artifacts/qpjdoim1_image.png',
  },
  {
    slug: 'elena-munoz-mendez',
    name: 'Elena Muñoz Méndez',
    roleEs: 'Project Innovation Technical Manager',
    roleEn: 'Project Innovation Technical Manager',
    bioEs: 'Puente entre I+D y operaciones. Despliega pilotos digitales e IoT con impacto medible en ciudad y servicios ambientales.',
    bioEn: 'Bridging R&D and operations to scale innovation. Deploying digital pilots and IoT solutions that deliver measurable impact in smart cities and environmental services.',
    icon: Target,
    color: '#ec4899',
    linkedin: 'https://www.linkedin.com/in/elenamunozmendez/',
    photo: 'https://customer-assets.emergentagent.com/job_valoriza-ideas/artifacts/39s64qg3_image.png',
  },
];
